<template>
<div class="chapter">
<div class="inner_page">
<p class="C159"><a id="page_v">Contents</a></p><a id="page_v">
</a><p class="C169"><a id="page_v"></a><a href="#/html/04_Foreword#page_1">Foreword</a></p>
<p class="C171"><a href="#/html/05_Introduction__The_Arrival_of_the#page_9">Introduction: The Arrival of the Queen of Heaven</a></p>
<p class="C171"><a href="#/html/06_1__Setting_the_Stage#page_16">1. Setting the Stage</a></p>
<p class="C171"><a href="#/html/07_2___Arise__Light_of_the_Senses#page_31">2. ‘Arise, Light of the Senses’</a></p>
<p class="C169"><span href="#/html/08_3__Why_Symphony#page_46" title="Link target outside of Sample">3. Why Symphony?</span></p>
<p class="C171"><span href="#/html/09_Interlude___Behind_the_Scenes__A#page_71" title="Link target outside of Sample">Interlude – Behind the Scenes: Alma and Walter, August–September 1910</span></p>
<p class="C171"><span href="#/html/10_4__God_or_Demon#page_75" title="Link target outside of Sample">4. God or Demon?</span></p>
<p class="C171"><span href="#/html/11_5__Approaching_the_Inexpressible#page_93" title="Link target outside of Sample">5. Approaching the Inexpressible: Words and Music in Mahler’s Eighth Symphony</span></p>
<p class="C171"><span href="#/html/12_6__Questions_of_Identity#page_145" title="Link target outside of Sample">6. Questions of Identity</span></p>
<p class="C171"><span href="#/html/13_7__The_Shadow_Falls#page_209" title="Link target outside of Sample">7. The Shadow Falls</span></p>
<p class="C169"><span href="#/html/14_8___To_Live_for_You__To_Die_for#page_227" title="Link target outside of Sample">8. ‘To Live for You, To Die for You’</span></p>
<p class="C171"><span href="#/html/15_Coda__14_September_1910_18_May_1#page_289" title="Link target outside of Sample">Coda: 14 September 1910–18 May 1911</span></p>
<p class="C171"><span href="#/html/16_Notes#page_295" title="Link target outside of Sample">Notes</span></p>
<p class="C171"><span href="#/html/17_Acknowledgements#page_301" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="C171"><span href="#/html/18_Index#page_303" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Contents.vue?7bb920f9